<template>
    <div class="category-card">
        <div class="card-item" @click="handlecateringBusinessClick">
            <img src="../../../assets/img/caring_business@3x.png" alt="">
        </div>
        <div class="card-item" @click="handleOnlineSelectionClick">
            <img src="../../../assets/img/online_selection@3x.png" alt="">
        </div>
    </div>
</template>
<script>
export default {
    name: 'categoryCards',
    data() {
        return {}
    },
    props: {
        cateringBusinessUrl: [String],
        onlineSelectionUrl: [String]
    },
    methods: {
        handlecateringBusinessClick() {
            this.$emit('cateringBusinessClick', this.cateringBusinessUrl)
        },
        handleOnlineSelectionClick() {
            this.$emit('onlickSelectionClick', this.onlineSelectionUrl)
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../../assets/css/px2rem.scss';
.category-card {
    display: flex;
    box-sizing: border-box;
    .card-item {
        width: px2rem(168);
        height: px2rem(80);
        margin: px2rem(15);
        border-radius: px2rem(2);
        overflow: hidden;
        &:nth-child(odd) {
            margin-right: px2rem(7);
        }
        &:nth-child(even) {
            margin-left: px2rem(7);
        }
        img{
            width: 100%;
            height: 100%;
        }
    }
}
</style>


